var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.topbar},[_c('div',{staticClass:"mb-0 mr-auto d-xl-block d-none"}),_c('div',{staticClass:"mr-4 d-none d-sm-block"}),_c('div',{staticClass:"mr-4 d-none d-sm-block"}),_c('div',[_c('cui-user-menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }